import cx from "classnames";
import React from "react";
import * as styles from "./OverlayFooter.module.css";
const OverlayFooter = ({
  testId = "overlay",
  content,
  actionButtons,
  showShadow
}) => /* @__PURE__ */ React.createElement("div", {
  className: cx(styles.root, {
    [styles.overlayFooterShadow]: showShadow
  }),
  "data-testid": `${testId}-footer`
}, content && /* @__PURE__ */ React.createElement("div", {
  className: styles.overlayFooterContent,
  "data-testid": `${testId}-footer-content`
}, content), /* @__PURE__ */ React.createElement("div", {
  className: styles.overlayFooterActionButtons
}, actionButtons));
var OverlayFooter_default = OverlayFooter;
export {
  OverlayFooter_default as default
};
